import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CHUNK = 4 * 1024 * 1024;

export const MAX_FILE_BYTES = 200 * 1024 * 1024;
export const ACCEPT = ".pdf,.jpg,.jpeg,.png,.webp,.gif,.docx,.doc,.txt,.mp4,.webm,.mov,.mp3,.m4a,.wav,.ogg";

export const kindOf = (file) => {
  const t = file.type || "";
  if (t.includes("pdf")) return "pdf";
  if (t.startsWith("image/")) return "image";
  if (t.startsWith("video/")) return "video";
  if (t.startsWith("audio/")) return "audio";
  return "file";
};

export const humanSize = (n = 0) => (n < 1024 * 1024 ? `${Math.max(1, Math.round(n / 1024))} KB` : n < 1024 ** 3 ? `${(n / 1024 ** 2).toFixed(1)} MB` : `${(n / 1024 ** 3).toFixed(2)} GB`);

// Sequential chunked upload: POST /files/chunk per slice, then /files/complete assembles + stores.
export async function uploadChunked({ file, matterId, category, attachedTo, onProgress }) {
  if (file.size > MAX_FILE_BYTES) throw new Error(`File exceeds ${humanSize(MAX_FILE_BYTES)} limit`);
  const uploadId = `up_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  for (let i = 0; i < total; i++) {
    const form = new FormData();
    form.append("chunk", file.slice(i * CHUNK, Math.min(file.size, (i + 1) * CHUNK)), `${i}.part`);
    form.append("uploadId", uploadId);
    form.append("index", String(i));
    await axios.post(`${API}/files/chunk`, form, {
      onUploadProgress: (e) => onProgress?.(Math.min(99, Math.round(((i + (e.total ? e.loaded / e.total : 1)) / total) * 95))),
    });
  }
  onProgress?.(97);
  const { data } = await axios.post(`${API}/files/complete`, {
    uploadId, total, filename: file.name, contentType: file.type || "application/octet-stream",
    matterId, category: category || null, attachedTo: attachedTo || null,
  });
  onProgress?.(100);
  return data;
}
